

// import "../components/videoKyc/constants/common";
import moment from "moment";

import Base64 from "../constants/base64Encoding";
import Validation from "./validation";

var userDetails = {
	poi: {
		doc_type: "",                         
		doc_type_context: "",                 
		doc_file: "https://s3-us-west-1.amazonaws.com/cavacserv9dev/KYC_Documents/HP20161125143505498587529HPPOI.jpeg"
	},
	poa: {
		doc_type: "",                         
		doc_type_context: "",                 
		doc_file: "https://s3-us-west-1.amazonaws.com/cavacserv9dev/KYC_Documents/HP20161125143505498587529HPPOA.jpg"
	},
	photo: {
		doc_type: "",                         
		doc_type_context: "",                 
		doc_file: "https://s3-us-west-1.amazonaws.com/cavacserv9dev/KYC_Documents/HP20161125143505498587529HPPHOTO.jpeg"
	},
	name: "Piyush",
	email: "piyush.dubey@happay.in",
    mob_num: "8762445825",
    mobile_verified: false,
	address: {
        address_line_1: "",
        address_line_2: "",
        city: "",
        state: "",
        zip_code: "",
        country: "India"
    }
};
var capturePan = false;
var documentKycAllowed = true;
var videoKycAllowed = true;
var consentCapture = true;
var photoData = null;
var poiData = null;
var poaData = null;

//  Pending  - 0
//  Declined - 98
//  Approved - 99
var kycStatus = 0;

var videoKYCStepStatus = {};

var isRejectedUpdate = false;
var updatedStepName = "";

var completedSteps = [];
var aadhaarXMLDetails = null;

var imgObj = null;

var pendingOnOPS = false;

var locationCaptured = false;
var locationRequired = false;

var documentKycPhotoLivenessCheck = false;

var reviewRequiredForPhoto = false;
var reviewRequiredForPoi = false;
var reviewRequiredForPoa = false;

//Show Toaster
export const showLoader = (isShow = false) => {
    const element = document.getElementById("loader-container");

    if (element) {
        if(isShow) {
            element.style.display = "block";
        } else {
            element.style.display = "none";
        }
    }
};

//Show Toaster
export const showMsg = (msg, isHide = true) => {
    const element = document.getElementById("snackbar");
    if (element && msg !== "") {
        element.style.visibility = "visible";
        element.innerHTML = msg;

        if(isHide) {
            setTimeout(() => {
                document.getElementById("snackbar").style.visibility = "hidden";
            }, 1500);
        }
    }
};

//Format Date
export const FormatDate = (value, format) => {
    let getDate = "", getMonth = "", getYear = "";
    if(typeof value === "object") {
        let date = new Date(value);
        getDate = date.getDate() < 10 ? `0${date.getDate()}` : date.getDate();
        getMonth =
            date.getMonth() + 1 < 10
                ? `0${date.getMonth() + 1}`
                : date.getMonth() + 1;
        getYear = date.getFullYear();
    } else {
        const seprator = value.includes("-") ? '-' : '/';
        const sepratorIndex1 = value.split(seprator)[0].length;  
  
        getDate = value.split(seprator)[0];
        getMonth = value.split(seprator)[1];
        getYear = value.split(seprator)[2];

        if(sepratorIndex1 === 4) {
            getYear = value.split(seprator)[0];
            getDate = value.split(seprator)[2];
        }
    }
    const formatObj = {
        "DD-MM-YYYY": `${getDate}-${getMonth}-${getYear}`,
        "YYYY-MM-DD": `${getYear}-${getMonth}-${getDate}`,
        "DD/MM/YYYY": `${getDate}/${getMonth}/${getYear}`,
        "YYYY/MM/DD": `${getYear}/${getMonth}/${getDate}`
    };
    return formatObj[format];
};

//init Data
export const initData = (data = {}) => {
    const {user_details = {}, capture_pan = false, document_kyc_allowed = true, video_kyc_allowed = true,
        aadhaar_consent_capture = false, vkyc_steps_status = {}, aadhaar_xml_details = null, pending_on_ops = false,
        location_captured = false, location_required = false, document_kyc_photo_liveness_check = false} = data;

    userDetails = user_details;
    kycStatus = user_details.kyc_status;
    capturePan = capture_pan;
    documentKycAllowed = document_kyc_allowed;
    videoKycAllowed = video_kyc_allowed;
    consentCapture = aadhaar_consent_capture;
    videoKYCStepStatus = vkyc_steps_status;
    aadhaarXMLDetails = aadhaar_xml_details;
    poiData = user_details.poi;
    poaData = user_details.poa;

    photoData = {doc_file: "", dob: user_details.dob};
    if(user_details.photo) {
        photoData = {doc_file: user_details.photo.doc_file, dob: user_details.dob, name: userDetails.name};
    }

    pendingOnOPS = pending_on_ops;

    locationCaptured = location_captured;
    locationRequired = location_required;

    documentKycPhotoLivenessCheck = document_kyc_photo_liveness_check;

    userDetails.photo && setReviewRequiredForPhoto(userDetails.photo.review_required);
    userDetails.poi && setReviewRequiredForPoi(userDetails.poi.review_required);
    userDetails.poa && setReviewRequiredForPoa(userDetails.poa.review_required);
};

export const isAadhaarXml = () => {
    return aadhaarXMLDetails;

    // For Local Testing

    // return {
    //     "aadhaar_number": "XXXXXXXX9829",
    //     "care_of": "S/O Ravi Kumar Shukla",
    //     "dob": "28-07-1994",
    //     "gender": "M",
    //     "house_number": "Plot No-46, 1st Floor",
    //     "landmark": "",
    //     "locality": "Gopalpura Bypass",
    //     "name": "Ashutosh Shukla",
    //     "photo": "https://lh3.googleusercontent.com/-Z27rAk2dR3s/X9xWDA8l36I/AAAAAAAAA2o/XR8GIk_32owtOn_u8YQzy8wR-VUrlEiXgCLcBGAsYHQ/s0/Screenshot%2B2020-12-16%2Bat%2B2.58.26%2BPM.png",
    //     "street": "Bhagirath Nagar",
    //     "timestamp": "2020-12-16 11:51:32.735 +0530 IST",
    //     "post_office": "",
    //     "sub_district": "",
    //     "district": "",
    //     "vtc": "",
    //     "state": "",
    //     "country": "",
    //     "pin_code": ""
    // }
}

//Get User Details
export const getUserDetails = () => {
    return userDetails;
};

// isDocumentKycAllowed
export const isDocumentKycAllowed = () => {
    return documentKycAllowed;
}

// isVideoKycAllowed
export const isVideoKycAllowed = () => {
    return videoKycAllowed;
}

export const getChannelName = () => {
    const channelName = sessionStorage.getItem("happayVideoKyc.channelName") || "";
    return channelName?.toLowerCase();
}

//check for document KYC pending
export const isDocumnetKycPending = () => {
    return documentKycAllowed && getDocumentKycStatus() === "pending";
}

//check for document KYC rejected
export const isDocumnetKycRejected = () => {
    return documentKycAllowed && getDocumentKycStatus() === "rejected";
}

//Set for review Required for photo
export const setReviewRequiredForPhoto = (data) => {
    reviewRequiredForPhoto = data;
}

//Set for review Required for poi
export const setReviewRequiredForPoi = (data) => {
    reviewRequiredForPoi = data;
}

//Set for review Required for poa
export const setReviewRequiredForPoa = (data) => {
    reviewRequiredForPoa = data;
}

//Get for review Required for poa
export const isReviewRequiredForPhoto = () => {
    return reviewRequiredForPhoto;
}

//Get for review Required for poa
export const isReviewRequiredForPoi = () => {
    return reviewRequiredForPoi;
}

//Get for review Required for poa
export const isReviewRequiredForPoa = () => {
    return reviewRequiredForPoa;
}

//check for Video KYC pending
export const isVideoKycPending = () => {
    return videoKycAllowed && checkForVideoKYCData(videoKYCStepStatus);
}

//check for Video KYC pending
export const isScheduleCall = () => {
    if(videoKycAllowed && videoKYCStepStatus) {
        if(Object.keys(videoKYCStepStatus).length) {
            return "SCHEDULE_CALL" in videoKYCStepStatus;
        } 
    }
}

export const getVideoKycStatus = () => {
    let videoKycStatus = "INITIATED";
    let count = 0;
    if(videoKycAllowed) {
        for(let item in videoKYCStepStatus) {
            if(videoKYCStepStatus[item]) {
                count++;
                videoKycStatus = "pending";
            }
        } 
        if(count === Object.keys(videoKYCStepStatus).length) {
            videoKycStatus = "success";
        }
    }

    return videoKycStatus;
}

//Return True if any state is true of video KYC
export const checkForVideoKYCData = (obj = {}) => {
    for(let item in obj) {
        if(obj[item]) {
            return true;
        }
    }
    return false;
}

//Get KYC Type and Statuses
export const getKycType = () => {
    let kycType = "";
    if(documentKycAllowed && videoKycAllowed) {
        kycType = "both";
    } else if(documentKycAllowed) {
        kycType = "Document";
    } else if(videoKycAllowed) {
        kycType = "Video";
    }

    return kycType;
}

//check for Video KYC pending
export const isPendingOnOps = () => {
    return pendingOnOPS;
}

//check for Video KYC pending
export const isShowVKycPendingOnOpsPage = () => {
    let isAadhaarVerificationDone = false;
    if("AADHAAR_VERIFICATION" in videoKYCStepStatus) {
        isAadhaarVerificationDone = videoKYCStepStatus.AADHAAR_VERIFICATION;
    }
    return pendingOnOPS && isAadhaarVerificationDone && userDetails.kyc_status !== 99;
}

// check for empty obj
export const isEmptyItem = (obj = {}) => {
    for(let item in obj) {
        if(typeof obj[item] === "string") {
            if(item !== "name" && item !== "email" && item !== "mob_num") {
                if(obj[item].length > 0) {
                    return false;
                }
            }
        } else if(typeof obj[item] === "object") {
            if(isEmptyItem(obj[item]) === false) {
                return false;
            } else {
                isEmptyItem(obj[item])
            }
        }
    }
    return true;
}

// check for empty obj
export const isFullObj = (obj = {}) => {
    for(let item in obj) {
        if(typeof obj[item] === "string") {
            if((item === "doc_file" || item === "doc_type_context") && !obj[item]) {
                return false;
            }
        } 
    }
    return true;
}

//Get KYC Type and Statuses
export const getDocumentKycStatus = () => {
    let kycStatusStr = "INITIATED";
    let isFullItem = false;

    if(userDetails.photo && userDetails.poi && userDetails.poa) {
        isFullItem = true;
    }

    if(checkForReviewRequired()) {
        kycStatusStr = "rejected";
    }
    //  else if(kycStatus === 98) {
    //     kycStatusStr = "success";
    // }
    else if(!isFullItem) {
        kycStatusStr = "INITIATED";
    } else if(kycStatus === 0 && isFullItem && !checkForReviewRequired()) {
        kycStatusStr = "pending";
    }

    // INITIATED
    // kycStatus === 0 && isEmptyItem(userDetails)

    return kycStatusStr;
};

export const checkForReviewRequired = () => {
    let isRejected = false;
    for(const docData in userDetails) {
        if(docData === "photo" || docData === "poi" || docData === "poa") {
            for(const item in userDetails[docData]) {
                if(item === "review_required" && userDetails[docData][item]) {
                    isRejected = true;
                }   
            }   
        }
    }
    return isRejected;
}

export const isPending = () => {
    return getDocumentKycStatus() === "pending";
}

export const setRejectedStatus = (isEdited= false, stepName = "") => {
    isRejectedUpdate = isEdited;
    updatedStepName = stepName;
}

export const isRejected = () => {
    return getDocumentKycStatus() === "rejected" && !isRejectedUpdate;
}

export const getUpdatedStepName = () => {
    return updatedStepName;
}

const b64toBlob = (b64Data, contentType='', sliceSize=512) => {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];
  
    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);
  
      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
  
      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
    const blob = new Blob(byteArrays, {type: contentType, name: `file.${contentType}`});
    // var tmp_path = URL.createObjectURL(blob);
    return blob;
}

export const setImgObj = (obj) => {
    imgObj =  obj;
}

export const getImgObj =  () => {
    return imgObj;
}

//Convert s3 to Blob
export const convertBase64toBlob = (url) => {
    let contentType = 'image/png';

    if(isPDF(url)) {
        contentType = "application/pdf";
    }
    
    if(url.includes("base64,")) {
        url = url.split("base64,")[1];
    }
    return b64toBlob(url, contentType);
}


//check for PDF extension
export const isPDF = (url = "") => {
    const decoded = Base64.decode(url);

    if(url.startsWith("/")) {
        return false;
    } else if(url.startsWith("data:")) {
        if(url.includes("base64,")) {
            let base64URL = url.split("base64,")[1];
            if(base64URL.startsWith("/")) {
                return false;
            } 
        }
    } 
    // do something like this
    var lowerCase = decoded.toLowerCase();
    
    return lowerCase.includes("pdf");
}


// GET Personal Details
export const getPersonalDetails = () => {
    let data  = {
        name: userDetails.name || "",
        email: userDetails.email || "",
        dob: userDetails.dob || "",
        photo: userDetails.photo && userDetails.photo.doc_file,
        address: userDetails.address || {
            address_line_1: "",
            address_line_2: "",
            city: "",
            state: "",
            zip_code: "",
            country: "India"
        },
    }
    return data;
};

// Set Photo Data
export const setPhotoData = (data) => {
    photoData = data;
}

// GET Photo Data
export const getPhotoData = () => {
    return photoData || {};
};

// SET Poi Data
export const setPoiData = (data) => {
    poiData = data;
}

// GET Identity Data
export const getPoiData = () => {
    return poiData || {};
};

// GET Poa Data
export const setPoaData = (data) => {
    poaData = data;
}

// GET POA Data
export const getPoaData = () => {
    return poaData || {};
};

//is Only PAN Number
export const isOnlyPAN = () => {
    return capturePan;
};

// isConsentCapture
export const isConsentCapture = () => {
    return consentCapture;
}

// Set Consent Capture status
export const setConsentCapture = () => {
    consentCapture = true;
}

// Exit From Kyc
export const exitFromKyc = (props, isFrom) => {    
    //List of reducers to reset while coming back to landing page, later we initialize root reducer to init state
    props.setOtpRes(null);
    props.setCaptchaRes(null);
    props.photoRes(null);
    props.checkPhotoLivenessFailedRes(null);
    props.setLimitedKyc(null);
    props?.quickKycVerifyFailRes(null);
    props?.quickKycValidateOtpRes(null);
    props?.quickKycGenerateOtpRes(null);

    // HDFC Video KYC header
    props?.hdfcBankEKYCRes(null);
    props?.hdfcBankVKycRes(null);
    
    /////////

    const {pathname = ""} = window?.location;
    const splitPathname = pathname?.split("/");
    const channelName = splitPathname?.[1];
    let userToken = splitPathname?.[2];

    if(userToken) {
        sessionStorage.removeItem("happayVideoKyc.userToken");
        sessionStorage.removeItem("happayVideoKyc.channelName");
        sessionStorage.setItem("happayVideoKyc.userToken", userToken);
        sessionStorage.setItem("happayVideoKyc.channelName", channelName.toUpperCase());
    } else {
        userToken = sessionStorage.getItem("happayVideoKyc.userToken");
    }

    if(!userToken) {
            // errMsg: `User token is missing in URL.`
    } else {
        const reqData = {
            user_token: userToken,
        };
        
        if(!(isDocumnetKycPending() && isFrom === "layout"))  {
            props.getCurrentState(reqData);
        }
    }
}


// Set Completed Steps 
export const setCompletedSteps = (data) => {
    completedSteps = data;
}

// Get Completed Steps 
export const getCompletedSteps = () => {
    return completedSteps;
}

// Get Context Type
export const getContextType = (type) => {
    const obj = {
        "Aadhaar Card": "AADHAAR",
        "Driving License": "DRIVING_LICENCE",
        "PAN Card": "PAN",
        "Voter ID": "VOTER_ID",
        "Passport": "PASSPORT"
    }

    return obj[type];
} 

// Get Context Type
export const getContextName = (type) => {
    const obj = {
        "AADHAAR": "Aadhaar Card",
        "DRIVING_LICENCE": "Driving License",
        "PAN": "PAN Card",
        "VOTER_ID": "Voter ID",
        "PASSPORT": "Passport"
    }

    return obj[type];
}

// is Valid Doc Type
export const isValidDocId = (docType, docId) => {
    docId = docId.toUpperCase();
    const obj = {
        "Aadhaar Card": docId.length === 12,
        "Driving License": docId.length <= 16,
        "PAN Card": docId.length === 10 && Validation.isValidPAN.test(docId),
        "Voter ID": docId.length === 10,
        "Passport": docId.length === 8 && Validation.isValidPassport.test(docId)
    }
    return obj[docType];
}


// is Valid Doc Type
export const getMaxLength = (docType) => {
    const obj = {
        "Aadhaar Card": 12,
        "Driving License": 16,
        "PAN Card": 10,
        "Voter ID": 10,
        "Passport": 8,
        "cKYC Number": 14
    }
    return obj[docType];
}

export const getPlaceholder = (docType) => {
    const obj = {
        "Aadhaar Card": "e.g. XXXX XXXX 2345",
        "Driving License": "e.g. UP93 201*****780",
        "PAN Card": "e.g. ANUQE****B",
        "Voter ID": "e.g. STN3****74",
        "Passport": "e.g. Z3****91",
        "cKYC Number": "e.g. 789****001"
    }
    return obj[docType];
}

export const _dateFormat = (format, date) => {
    date = date || new Date();
    return moment.utc(date).format(format || 'lll');
}

export const setLocationCaptured = () => {
    locationCaptured =  true;
}

export const isLocationCaptured = () => {
    return locationCaptured;
}

export const isLocationRequired = () => {
    return locationRequired;
}

export const setDocumentKycPhotoLivenessCheck = () => {
    documentKycPhotoLivenessCheck = true;
}

export const isDocumentKycPhotoLivenessCheck = () => {
    return documentKycPhotoLivenessCheck;
}

